export const PER_PAGE = 10

export const DUAL_PANEL_SELECTABLE_TYPES = {
  students: 'students',
  programs: 'programs',
  programsWithPackages: 'programsWithPackages',
  // Added for future usage
  series: 'series',
}
